<section class="container bg-gradient border pb-5 mb-32">
  <h1 class="ml-5 pt-5 pb-5 strong text-white text-shadow font-italic">Política de Privacidade</h1>
  <div class="row pl-3">
    <div class="col-md-12 sup">
      <img src="../../assets/fa-iconmages/logo/faria.png" class="img-fluid logo-tc" />
    </div>
  </div>
  <div class="row d-flex justify-content-center -mt-5">
    <div class="col-md-10">
      <div class="mb-5 jumbotron">
        <p class="text-justify">
          Relojoaria Faria é uma marca registada da empresa Relojoaria Faria, Lda (adiante designada por Relojoaria Faria). A empresa Relojoaria Faria, Lda é uma empresa constituída em Portugal com sede social no Largo Afonso de Albuquerque, nº 7 - 2710-519 Sintra e/ou as suas filiais e subsidiárias específicas (coletivamente referidas como "Relojoaria Faria", "nós", "nosso" na presente Nota de Privacidade) está empenhada em proteger a privacidade e segurança das suas informações pessoais. O objetivo desta nota de privacidade ("Nota de Privacidade") é fornecer-lhe informações sobre como e porquê a Relojoaria Faria recolhe e processa os seus dados pessoais quando visita este website, e/ou quando subscreve as nossas newsletters, subscreve qualquer um dos nossos white papers publicados, pergunta sobre os nossos serviços, participa num inquérito ou interage de qualquer outra forma connosco.
        </p>
      </div>
    </div>
  </div>
  <!--Fecha quando clico noutro-->
  <div class="container">
    <div class="row d-flex justify-content-center">
      <div class="col-md-10">
        <div class="jumbotron">
          <div class="accordion" id="accordionExample">
            <div class="card-header" id="headingOne">
              <h2 class="mb-0 panel-title">
                <button class="btn btn-link btn-block text-decoration-none text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" id="btn1">
                  <div class="row">
                    <div class="col-md-10">
                      <span class="textColor mine-shaft base a-font-style h2 font-italic strong">
                        1 – Quem Somos
                      </span>
                    </div>
                    <div class="col-md-2">
                      <fa-icon [icon]="btnOne.classList.value.includes('collapsed') ? faPlus : faMinus" class="fas fa-minus ml-5 textColor shark base"></fa-icon>
                    </div>
                  </div>
                </button>
              </h2>
            </div>
            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
              <div class="card-body">
                <p class="text-justify">
                  A Relojoaria Faria é a responsável pelo tratamento de dados e é responsável por este website em termos da Regulamentação Europeia de Proteção de Dados (RGPD). Nomeámos um responsável pela proteção de dados (RPD) que é responsável pela supervisão das questões relacionadas com esta nota sobre a proteção de dados. Se tiver quaisquer perguntas sobre esta nota de privacidade, incluindo quaisquer pedidos para exercer os seus direitos legais, por favor
                  <a class="textColor mdb-color darken-4" href="/contactus">contacte-nos</a>.
                </p>
              </div>
            </div>
            <div class="card-header" id="headingTwo">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-decoration-none text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" id="btn2">
                  <div class="row">
                    <div class="col-md-10">
                      <span class="textColor mine-shaft base a-font-style h2 font-italic strong">
                        2 - Os Dados Pessoais Que Recolhemos Sobre Si
                      </span>
                    </div>
                    <div class="col-md-2">
                      <fa-icon [icon]="btnTwo.classList.value.includes('collapsed') ? faPlus : faMinus" class="fas fa-plus ml-5 textColor shark base"></fa-icon>
                    </div>
                  </div>
                </button>
              </h2>
            </div>
            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
              <div class="card-body">
                <p class="text-justify">
                  Por dados pessoais entende-se quaisquer dados ou informações sobre um indivíduo a partir dos quais essa pessoa possa ser identificada. Não inclui dados onde a sua identidade tenha sido removida (dados anónimos). Podemos recolher, utilizar, armazenar, e transferir diferentes tipos de dados pessoais sobre si, que agrupámos da seguinte forma:
                </p>
                <ul class="list-group list-group-flush p-3">
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    Dados de contacto que incluem o seu endereço postal, endereço(s) eletrónico(s) e números de telefone.
                  </li>
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    Dados de identidade, que incluem o seu nome, apelido, título, sexo, data de nascimento e título de emprego.
                  </li>
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    Dados de marketing e comunicação, que incluem as suas preferências na receção de marketing da nossa parte, e as suas preferências de comunicação.
                  </li>
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    Os dados do perfil incluem o seu nome de utilizador e palavra-passe, preferências, feedback e respostas ao inquérito.
                  </li>
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    Os dados técnicos incluem o endereço de protocolo de Internet (IP), os seus dados de login, tipo e versão do browser, configuração e localização do fuso horário, tipos e versões de plug-in do browser, sistema operativo e plataforma e outra tecnologia nos dispositivos que utiliza para aceder a este website.
                  </li>
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    Os dados de uso incluem informações sobre como você usa nosso site.
                  </li>
                </ul>
                <p class="pt-2 text-justify">
                  Podemos utilizar os dados pessoais acima mencionados para formar uma opinião sobre o que pensamos que poderá querer ou precisar, ou o que poderá ser do seu interesse. Poderá receber comunicações de marketing da nossa parte se nos tiver solicitado informações ou adquirido serviços, ou se nos tiver fornecido os seus dados quando entrou num inquérito ou se registou para um evento ou promoção, e, em cada caso, não tiver optado por não receber esse marketing. Pode dizer-nos para não o contactar com comunicações de marketing no momento da recolha dessas informações ou seguindo as instruções para cancelar a subscrição em qualquer comunicação que lhe seja enviada. Tenha em atenção que, se optar por não receber mensagens de marketing, tal não eliminará outros dados pessoais que tenhamos sobre si. Não recolhemos dados pessoais sobre o utilizador para além das informações que este nos fornece voluntariamente através deste site para cumprir o objetivo do seu pedido, tal como a subscrição de um boletim informativo. Note que este website não se destina a crianças, e a Relojoaria Faria não recolhe intencionalmente dados relativos a crianças. Se for menor de 16 anos, não poderá registar-se ou utilizar este sítio web. Se pensa que podemos ter recolhido involuntariamente dados relativos a uma criança, por favor contacte-nos. Não recolhemos quaisquer categorias especiais de dados pessoais (conforme definido pelo RGPD) sobre o utilizador através do nosso website ou de qualquer um dos produtos ou serviços aqui mencionados.
                </p>
              </div>
            </div>

            <div class="card-header" id="headingThree">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-decoration-none text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree" id="btn3">
                  <div class="row">
                    <div class="col-md-10">
                      <span class="textColor mine-shaft base a-font-style h2 font-italic strong">
                        3 - Como Recolhemos os Seus Dados
                      </span>
                    </div>
                    <div class="col-md-2">
                      <fa-icon [icon]="btnThree.classList.value.includes('collapsed') ? faPlus : faMinus" class="fas fa-plus ml-5 textColor shark base"></fa-icon>
                    </div>
                  </div>
                </button>
              </h2>
            </div>
            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
              <div class="card-body">
                <p>
                  Pode dar-nos a sua identidade, contacto, marketing, e dados de comunicação preenchendo formulários ou correspondendo connosco por correio, telefone, e-mail ou outro meio. Isto inclui os dados pessoais que nos fornecer quando nos fornecer:
                </p>
                <ul class="list-group list-group-flush p-3">
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    preencher um formulário neste website (tal como o da nossa página de "Contactos")
                  </li>
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    criar uma conta no nosso website
                  </li>
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    subscrever qualquer publicação
                  </li>
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    solicitar que o marketing lhe seja enviado; ou
                  </li>
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    quando nos dá algum feedback
                  </li>
                </ul>
                <p class="text-justify">
                  Tecnologias ou interações automatizadas. À medida que interage com o nosso sítio web, podemos recolher automaticamente dados técnicos sobre o seu equipamento, ações de navegação e padrões. Recolhemos estes dados pessoais utilizando cookies, registos de servidor e outras tecnologias semelhantes.
                </p>
                <p>
                  Pode configurar o seu navegador para recusar todo ou algum navegador cookies, ou para o alertar quando os sítios web definem ou acedem a cookies. Note que quando desativar ou recusar os cookies, algumas partes deste site podem tornar-se inacessíveis ou podem não funcionar devidamente. Com respeito aos cookies e à análise de dados, que são capturados quando visita o nosso website, consulte por favor a nossa política de cookies neste
                  <a class="textColor mdb-color darken-4 strong" href="/terms">link</a>.
                </p>
              </div>
            </div>
            <div class="card-header" id="headingFour">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-decoration-none text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour" id="btn4">
                  <div class="row">
                    <div class="col-md-10">
                      <span class="textColor mine-shaft base a-font-style h2 font-italic strong">
                        4 - Como Utilizamos os Seus Dados Pessoais
                      </span>
                    </div>
                    <div class="col-md-2">
                      <fa-icon [icon]="btnFour.classList.value.includes('collapsed') ? faPlus : faMinus" class="fas fa-plus ml-5 textColor shark base"></fa-icon>
                    </div>
                  </div>
                </button>
              </h2>
            </div>
            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
              <div class="card-body">
                <p class="text-justify">
                  Só utilizaremos os seus dados pessoais quando o GDPR nos permitir. Mais frequentemente, utilizaremos os seus dados pessoais nas seguintes circunstâncias:
                </p>
                <ul class="list-group list-group-flush p-3">
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    Onde precisarmos de executar o contrato que estamos prestes a celebrar ou que celebrámos consigo
                  </li>
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    Quando é necessário para os nossos interesses legítimos (ou de terceiros) e os seus interesses e direitos fundamentais não se sobrepõem a esses interesses
                  </li>
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    Onde precisamos de cumprir uma obrigação legal ou regulamentar
                  </li>
                </ul>
                <p class="text-justify">
                  Geralmente não confiamos no consentimento como base legal para processar os seus dados pessoais a não ser em relação ao envio de comunicações de marketing direto a terceiros através de correio eletrónico ou mensagem de texto. Apresentamos a seguir, em formato de tabela, uma descrição de todas as formas como podemos utilizar os seus dados pessoais, e a correspondente base legal em que nos baseamos para o fazer. Também identificámos aí quais são os nossos interesses legítimos, quando apropriado. Note que podemos processar os seus dados pessoais por mais de um motivo legal, dependendo da finalidade específica para a qual estamos a utilizar os seus dados:
                </p>
                <table class="table table-striped table-responsive">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col" class="lc-border-th">
                        Objetivo / Atividade
                      </th>
                      <th scope="col" class="lc-border-th">
                        Base legal para o processamento incluindo base de interesse legítimo
                      </th>
                      <th scope="col" class="lc-align-th">
                        Tipo de dados
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td scope="row" class="lc-border-td">
                        Para o registar como novo cliente, candidato, fornecedor, parceiro...
                      </td>
                      <td class="lc-border-td">
                        (a) Identidade <br>
                        (b) Contato <br>
                      </td>
                      <td class="lc-align-td">
                        Execução de um contrato consigo
                      </td>
                    </tr>
                    <tr>
                      <td scope="row" class="lc-border-td">
                        Para gerir a nossa relação consigo, que incluirá <br>
                        (a) Notificá-lo sobre alterações aos nossos termos ou aviso de privacidade <br>
                        (b) Pedir-lhe para deixar uma revisão ou fazer um inquérito
                      </td>
                      <td class="lc-border-td">
                        (a) Identidade <br>
                        (b) Contacto <br>
                        (c) Perfil <br>
                        (d) Marketing e Comunicação
                      </td>
                      <td class="lc-align-td">
                        (a) Execução de um contrato consigo <br>
                        (b) Necessário para cumprir uma obrigação legal <br>
                        (c) Necessário para os nossos interesses legítimos (para manter os nossos registos atualizados e para estudar a forma como os clientes utilizam os nossos produtos/serviços)
                      </td>
                    </tr>
                    <tr>
                      <td scope="row" class="lc-border-td">
                        Para lhe permitir completar um inquérito
                      </td>
                      <td class="lc-border-td">
                        (a) Identidade <br>
                        (b) Contacto <br>
                        (c) Perfil <br>
                        (d) Utilização <br>
                        (e) Marketing e Comunicação
                      </td>
                      <td class="lc-align-td">
                        (a) Necessário para os nossos interesses legítimos (para estudar a forma como os clientes utilizam os nossos produtos/serviços, para os desenvolver e fazer crescer o nosso negócio)
                      </td>
                    </tr>
                    <tr>
                      <td scope="row" class="lc-border-td">
                        Para administrar e proteger o nosso negócio e este website (incluindo resolução de problemas, análise de dados, testes, manutenção do sistema, apoio, relatórios e alojamento de dados)
                      </td>
                      <td class="lc-border-td">
                        (a) Identidade <br>
                        (b) Contato <br>
                        (c) Técnico
                      </td>
                      <td class="lc-align-td">
                        (a) Necessário para os nossos interesses legítimos (para a gestão dos nossos negócios, a prestação de serviços administrativos e informáticos, a segurança das redes, para prevenir a fraude e no contexto de uma reorganização empresarial ou de um exercício de reestruturação de grupo) (b) Necessário para cumprir uma obrigação legal
                      </td>
                    </tr>
                    <tr>
                      <td scope="row" class="lc-border-td">
                        Entregar-lhe o conteúdo relevante do sítio Web e medir ou compreender a sua eficácia
                      </td>
                      <td class="lc-border-td">
                        (a) Identidade <br>
                        (b) Contacto <br>
                        (c) Perfil <br>
                        (d) Utilização <br>
                        (e) Marketing e Comunicação <br>
                        (f) Técnica
                      </td>
                      <td class="lc-align-td">
                        (a) Necessário para nossos interesses legítimos (estudar como os clientes usam nosso site e / ou produtos / serviços, para desenvolvê-los, para expandir nossos negócios e para informar nossa estratégia de marketing)
                      </td>
                    </tr>
                    <tr>
                      <td scope="row" class="lc-border-td">
                        Utilizar a análise de dados para melhorar o nosso website, produtos/serviços, marketing, relações com clientes e experiências
                      </td>
                      <td class="lc-border-td">
                        (a) Técnica <br>
                        (b) Utilização
                      </td>
                      <td class="lc-align-td">
                        (a) Necessário para os nossos interesses legítimos (definir tipos de clientes para os nossos produtos e serviços, manter o nosso website atualizado e relevante, desenvolver o nosso negócio e informar a nossa estratégia de marketing)
                      </td>
                    </tr>
                    <tr>
                      <td scope="row" class="lc-border-td">
                        Fazer-lhe sugestões e recomendações sobre bens ou serviços que possam ser do seu interesse
                      </td>
                      <td class="lc-border-td">
                        (a) Identidade <br>
                        (b) Contacto <br>
                        (c) Técnico <br>
                        (d) Utilização e) Perfil
                      </td>
                      <td class="lc-align-td">
                        (a) Necessário para os nossos interesses legítimos (para desenvolver os nossos produtos/serviços e fazer crescer o nosso negócio)
                      </td>
                    </tr>
                    <tr>
                      <td scope="row" class="lc-border-td">
                        Para lhe permitir completar um inquérito
                      </td>
                      <td class="lc-border-td">
                        (a) Identidade <br>
                        (b) Contacto <br>
                        (c) Perfil <br>
                        (d) Utilização <br>
                        (e) Marketing e Comunicação
                      </td>
                      <td class="lc-align-td">
                        (a) Necessário para os nossos interesses legítimos (para estudar a forma como os clientes utilizam os nossos produtos/serviços, para os desenvolver e fazer crescer o nosso negócio)
                      </td>
                    </tr>
                    <tr>
                      <td scope="row" class="lc-border-td">
                        Para administrar e proteger o nosso negócio e este website (incluindo resolução de problemas, análise de dados, testes, manutenção do sistema, apoio, relatórios e alojamento de dados)
                      </td>
                      <td class="lc-border-td">
                        (a) Identidade <br>
                        (b) Contato <br>
                        (c) Técnico <br>
                      </td>
                      <td class="lc-align-td">
                        (a) Necessário para os nossos interesses legítimos (para a gestão dos nossos negócios, a prestação de serviços administrativos e informáticos, a segurança das redes, para prevenir a fraude e no contexto de uma reorganização empresarial ou de um exercício de reestruturação de grupo) (b) Necessário para cumprir uma obrigação legal
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-header" id="headingFive">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-decoration-none text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive" id="btn5">
                  <div class="row">
                    <div class="col-md-10">
                      <span class="textColor mine-shaft base a-font-style h2 font-italic strong">
                        5 - Divulgação dos Seus Dados Pessoais
                      </span>
                    </div>
                    <div class="col-md-2">
                      <fa-icon [icon]="btnFive.classList.value.includes('collapsed') ? faPlus : faMinus" class="fas fa-plus ml-5 textColor shark base"></fa-icon>
                    </div>
                  </div>
                </button>
              </h2>
            </div>
            <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
              <div class="card-body">
                <p class="text-justify">
                  Poderemos ter de partilhar os seus dados pessoais com terceiros para os fins indicados no quadro no parágrafo 4 acima. Exigimos a todos os terceiros que respeitem a segurança dos seus dados pessoais e que os tratem de acordo com a lei. Não permitimos que os nossos prestadores de serviços terceiros utilizem os seus dados pessoais para os seus próprios fins e apenas lhes permitimos processar os seus dados pessoais para fins específicos e de acordo com as nossas instruções.
                </p>
              </div>
            </div>
            <div class="card-header" id="headingSix">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-decoration-none text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix" id="btn6">
                  <div class="row">
                    <div class="col-md-10">
                      <span class="textColor mine-shaft base a-font-style h2 font-italic strong">
                        6 - Transferências Internacionais
                      </span>
                    </div>
                    <div class="col-md-2">
                      <fa-icon [icon]="btnSix.classList.value.includes('collapsed') ? faPlus : faMinus" class="fas fa-plus ml-5 textColor shark base"></fa-icon>
                    </div>
                  </div>
                </button>
              </h2>
            </div>
            <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordionExample">
              <div class="card-body">
                <p class="text-justify">
                  Somos uma empresa global com operações em países de todo o mundo. A Relojoaria Faria implementou práticas globais de privacidade para o processamento de dados pessoais protegidos ao abrigo de várias leis de proteção de dados. A Relojoaria Faria transfere dados pessoais entre os países em que opera, de acordo com as normas e condições das leis de privacidade de dados aplicáveis, incluindo normas e condições relacionadas com a segurança e o processamento. Se residir fora do Espaço Económico Europeu (EEE), ao fornecer os seus dados pessoais, consente a partilha dos seus dados pessoais, conforme descrito acima, e quaisquer transferências transfronteiriças daí resultantes. A transferência de dados entre empresas do Grupo Relojoaria Faria ou para terceiros pode implicar a transferência dos seus dados para fora do EEE. Sempre que transferimos os seus dados pessoais para fora do EEE, quer para empresas do Grupo Relojoaria Faria quer para terceiros, garantimos um grau adequado de proteção dos mesmos, assegurando a implementação de pelo menos uma das seguintes salvaguardas:
                </p>
                <ul class="list-group list-group-flush p-3">
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    Apenas transferiremos os seus dados pessoais para países que tenham sido considerados como fornecendo um nível adequado de proteção de dados pessoais pela Comissão Europeia. Para mais pormenores, ver
                    <a class="textColor mdb-color darken-4 strong" href="https://ec.europa.eu/fa-iconnfo/law/law-topic/data-protection/fa-iconnternational-dimension-data-protection/adequacy-decisions_en" target="_blank">Comissão Europeia: Adequação da proteção de dados pessoais em países não pertencentes à EU</a>; ou
                  </li>
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    Quando utilizamos determinados prestadores de serviços, podemos utilizar contratos específicos aprovados pela Comissão Europeia, que conferem aos dados pessoais a mesma proteção de que estes gozam na União Europeia. Para mais pormenores, ver
                    <a class="textColor mdb-color darken-4 strong" href="https://ec.europa.eu/fa-iconnfo/law/law-topic/data-protection/fa-iconnternational-dimension-data-protection/standard-contractual-clauses-scc_en" target="_blank">
                      Comissão Europeia: Modelos de contratos para a transferência de dados pessoais para países terceiros
                    </a>
                  </li>
                </ul>
                <p>
                  Se desejar mais informações sobre o mecanismo específico utilizado por nós na transferência dos seus dados pessoais para fora do EEA, por favor
                  <a class="textColor mdb-color darken-4 strong" href="/contactus"> contacte-nos</a>.
                </p>
              </div>
            </div>
            <div class="card-header" id="headingSeven">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-decoration-none text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven" id="btn7">
                  <div class="row">
                    <div class="col-md-10">
                      <span class="textColor mine-shaft base a-font-style h2 font-italic strong">
                        7 - Segurança de Dados
                      </span>
                    </div>
                    <div class="col-md-2">
                      <fa-icon [icon]="btnSeven.classList.value.includes('collapsed') ? faPlus : faMinus" class="fas fa-plus ml-5 textColor shark base"></fa-icon>
                    </div>
                  </div>
                </button>
              </h2>
            </div>
            <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
              <div class="card-body">
                <p class="text-justify">
                  Tomámos as medidas de segurança adequadas para evitar que os seus dados pessoais sejam acidentalmente perdidos, utilizados ou acedidos de forma não autorizada, alterados ou divulgados. Além disso, limitamos o acesso aos seus dados pessoais aos empregados, agentes, empreiteiros e outros terceiros que tenham uma necessidade comercial de saber. Só processarão os seus dados pessoais segundo as nossas instruções e estão sujeitos a um dever de confidencialidade. Criámos procedimentos para lidar com qualquer suspeita de violação de dados pessoais e notificaremos o utilizador e qualquer entidade reguladora aplicável de uma violação, sempre que formos legalmente obrigados a fazê-lo.
                </p>
                <strong>Recolha de informações por sites de terceiros </strong>
                <p class="pt-2 text-justify">
                  Como muitos outros sítios comerciais, o nosso sítio contém links para outros sítios cujas práticas de recolha de informação podem ser diferentes das nossas. Os utilizadores devem consultar as políticas de privacidade dos outros sítios, uma vez que não temos qualquer controlo sobre qualquer informação que possa ser submetida a, ou recolhida por tais terceiros. Embora empreguemos medidas de segurança para impedir o acesso não autorizado às informações que recolhemos on-line, não podemos garantir a privacidade dos dados pessoais que o utilizador transmite através da web, ou que possam ser recolhidos em trânsito por terceiros, incluindo quaisquer consultores que nos forneçam serviços.
                </p>
              </div>
            </div>
            <div class="card-header" id="headingEight">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-decoration-none text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight" id="btn8">
                  <div class="row">
                    <div class="col-md-10">
                      <span class="textColor mine-shaft base a-font-style h2 font-italic strong">
                        8 - Durante Quanto Tempo Retemos os Seus Dados Pessoais
                      </span>
                    </div>
                    <div class="col-md-2">
                      <fa-icon [icon]="btnEight.classList.value.includes('collapsed') ? faPlus : faMinus" class="fas fa-plus ml-5 textColor shark base"></fa-icon>
                    </div>
                  </div>
                </button>
              </h2>
            </div>
            <div id="collapseEight" class="collapse" aria-labelledby="headingEight" data-parent="#accordionExample">
              <div class="card-body">
                <p class="text-justify">
                  Conservaremos os seus dados pessoais apenas durante o tempo necessário para cumprir os objetivos para os quais os recolhemos, inclusive para satisfazer quaisquer requisitos legais, contabilísticos ou de apresentação de relatórios. Para determinar o período de retenção adequado dos dados pessoais, consideramos a quantidade, natureza e sensibilidade dos dados pessoais, o risco potencial de danos resultantes da utilização ou divulgação não autorizada dos seus dados pessoais, os fins para os quais processamos os seus dados pessoais e se podemos atingir esses fins através de outros meios, e os requisitos legais aplicáveis.
                </p>
              </div>
            </div>
            <div class="card-header" id="headingNine">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-decoration-none text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine" id="btn9">
                  <div class="row">
                    <div class="col-md-10">
                      <span class="textColor mine-shaft base a-font-style h2 font-italic strong">
                        9 - Os Seus Direitos Jurídicos
                      </span>
                    </div>
                    <div class="col-md-2">
                      <fa-icon [icon]="btnNine.classList.value.includes('collapsed') ? faPlus : faMinus" class="fas fa-plus ml-5 textColor shark base"></fa-icon>
                    </div>
                  </div>
                </button>
              </h2>
            </div>
            <div id="collapseNine" class="collapse" aria-labelledby="headingNine" data-parent="#accordionExample">
              <div class="card-body">
                <p class="text-justify">
                  Em determinadas circunstâncias e dependendo da sua localização, tem direitos ao abrigo das leis de proteção de dados aplicáveis em relação aos seus dados pessoais. Se estiver localizado na União Europeia, tem o direito de o fazer:
                </p>
                <ul class="list-group list-group-flush p-3">
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    Pedir acesso aos seus dados pessoais
                  </li>
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    Solicitea correção dos seus dados pessoais
                  </li>
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    Solicite o apagamento dos seus dados pessoais
                  </li>
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    Objeto ao tratamento dos seus dados pessoais
                  </li>
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    Pedido de restrição de tratamento dos seus dados pessoais
                  </li>
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    Solicite a transferência dos seus dados pessoais
                  </li>
                  <li class="list-group-item">
                    <fa-icon [icon]="faCheck" class="fas fa-check mr-2 textColor amber base"></fa-icon>
                    Retirar o seu consentimento
                  </li>
                </ul>
                <p class="text-justify">
                  ou não terá de pagar uma taxa para aceder aos seus dados pessoais (ou para exercer qualquer dos outros direitos). No entanto, poderemos cobrar uma taxa razoável se o seu pedido for claramente infundado, repetitivo ou excessivo. Em alternativa, poderemos recusar o cumprimento do seu pedido nestas circunstâncias. Poderá ser necessário solicitar informações específicas ao cliente para nos ajudar a confirmar a sua identidade e assegurar o seu direito de acesso aos seus dados pessoais (ou de exercício de quaisquer outros direitos). Esta é uma medida de segurança para garantir que os dados pessoais não sejam revelados a qualquer pessoa que não tenha direito a recebê-los. Podemos também contactar o cliente para lhe pedir mais informações em relação ao seu pedido, a fim de acelerar a nossa resposta. Tentamos responder a todos os pedidos legítimos no prazo de um mês. Ocasionalmente, pode demorar mais de um mês se o seu pedido for particularmente complexo ou se tiver feito uma série de pedidos. Neste caso, iremos notificá-lo e mantê-lo-emos informado. Se desejar exercer algum dos direitos acima indicados, queira utilizar os dados de contacto abaixo.
                </p>
              </div>
            </div>
            <div class="card-header" id="headingTen">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-decoration-none text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen" id="btn10">
                  <div class="row">
                    <div class="col-md-10">
                      <span class="textColor mine-shaft base a-font-style h2 font-italic strong">
                        10 - Detalhes de Contacto
                      </span>
                    </div>
                    <div class="col-md-2">
                      <fa-icon [icon]="btnTen.classList.value.includes('collapsed') ? faPlus : faMinus" class="fas fa-plus ml-5 textColor shark base"></fa-icon>
                    </div>
                  </div>
                </button>
              </h2>
            </div>
            <div id="collapseTen" class="collapse" aria-labelledby="headingTen" data-parent="#accordionExample">
              <div class="card-body">
                <p>Relojoaria Faria</p>
                <p>O email:
                  <a class="textColor mdb-color darken-4" href="mailto:info@relojoariafaria.pt">info&#64;relojoariafaria.pt</a>
                </p>
                <p>Endereço postal do encarregado da proteção de dados:</p>
                <p>Largo Afonso de Albuquerque, nº 7 - 2710-519 Sintra </p>
                <p>
                  Se for cidadão da União Europeia, tem o direito de formular uma queixa à autoridade de controlo, no Estado-Membro da sua residência habitual, local de trabalho ou local da alegada infração. A seguinte ligação ajudá-lo-á a encontrar a sua autoridade de tutela local
                  <a class="textColor mdb-color darken-4" href="https://edpb.europa.eu/about-edpb/board/members_en">
                    https://edpb.europa.eu/about-edpb/board/members_en
                  </a>
                  No entanto, agradecemos a oportunidade de tratar das suas preocupações antes de se dirigir à sua autoridade de tutela local.
                </p>
              </div>
            </div>
            <div class="card-header" id="headingEleven">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-decoration-none text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseEleven" aria-expanded="false" aria-controls="collapseEleven" id="btn11">
                  <div class="row">
                    <div class="col-md-10">
                      <span class="textColor mine-shaft base a-font-style h2 font-italic strong">
                        11 - Revisões a esta Nota de Privacidade
                      </span>
                    </div>
                    <div class="col-md-2">
                      <fa-icon [icon]="btnEleven.classList.value.includes('collapsed') ? faPlus : faMinus" class="fas fa-plus ml-5 textColor shark base"></fa-icon>
                    </div>
                  </div>
                </button>
              </h2>
            </div>
            <div id="collapseEleven" class="collapse" aria-labelledby="headingEleven" data-parent="#accordionExample">
              <div class="card-body">
                <p class="text-justify">
                  Podemos atualizar periodicamente este Aviso para cumprir os regulamentos de privacidade, descrever novas características do website, produtos ou serviços que oferecemos e como isso pode afetar a nossa utilização das informações sobre si. Esta Nota de Privacidade foi atualizada pela última vez a 15 de julho de 2021.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>